import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DatasetModel from '../../../../models/pipeline/steps/dataset';
import {FEATURE_FLAGS} from '../../../../services/feature_flags';
import DatasourceModel from '../../../../models/datasource';
import {
    inputBlurEvent,
} from '../../../../services/query_builder_events';
import stopEvent from '../../../../utils/stop_event';
import ColumnsGroup from './dataset_attributes/columns/columns';
import FiltersGroup from './dataset_attributes/filters/filters';

export default class QueryBuilderColumnFirst extends Component {
    inputRefs = {
        columns: React.createRef(),
        filters: React.createRef(),
    };
    queryBuilderRef = React.createRef();

    constructor(props) {
        super(props);
        this.removeAttribute = this.removeAttribute.bind(this);
    }

    componentDidMount() {
        if (FEATURE_FLAGS.FOCUS_COLUMN_INPUT_ON_LOAD) {
            this.inputRefs.measures.current.attributeRefs[0].focusColumnInput();
        }
    }

    removeAttribute(attribute) {
        this.props.onRemove(attribute);
        inputBlurEvent.emit();
    }

    forceUpdate(cb) {
        setTimeout(() => { super.forceUpdate(cb); }, 30);
    }

    shouldShowFilters() {
        const {dataset, open} = this.props;
        const prevFlag = !FEATURE_FLAGS.HIDE_DIMS_AND_FILTERS || this.props.dataset.columns.length || this.props.dataset.filters.length;
        if (prevFlag) {
            // we want to hide the filters if the dataset panel is not open and there are no filters
            return open || dataset.filters.length > 0;
        }

        return prevFlag;
    }

    render() {
        const {dataset, onClick, open} = this.props;

        return (
            <div
                className="query-builder-container"
                onClick={onClick}
                ref={this.queryBuilderRef}
            >
                <div
                    className={`input-container ${FEATURE_FLAGS.FILTERS_BESIDE ? 'filters-beside-columns' : ''}`}
                    onClick={onClick}
                >
                    <ColumnsGroup
                        dataset={dataset}
                        attributes={dataset.columns}
                        onRemove={this.removeAttribute}
                        ref={this.inputRefs.columns}
                        datasetOpen={open}
                    />
                </div>

                {this.shouldShowFilters() ?
                    (
                        <div className={FEATURE_FLAGS.FILTERS_BESIDE ? 'filters-beside-filters' : ''}>
                            <label className="label dataset-label-filters">FILTERS</label>
                            <div
                                className="input-container"
                                onClick={stopEvent((ev) => { onClick(ev); })}
                            >
                                <FiltersGroup
                                    dataset={dataset}
                                    attributes={dataset.filters}
                                    onRemove={this.removeAttribute}
                                    ref={this.inputRefs.filters}
                                    datasetOpen={open}
                                />
                            </div>
                        </div>
                    ) : null
                }
            </div>
        );
    }
}

QueryBuilderColumnFirst.propTypes = {
    datasource: PropTypes.instanceOf(DatasourceModel).isRequired,
    dataset: PropTypes.instanceOf(DatasetModel).isRequired,
    onChange: PropTypes.func.isRequired,
    open: PropTypes.bool,
};
